import { render } from "./past-vice-presidents.vue?vue&type=template&id=141099e2&scoped=true"
import script from "./past-vice-presidents.vue?vue&type=script&lang=js"
export * from "./past-vice-presidents.vue?vue&type=script&lang=js"

import "./past-vice-presidents.vue?vue&type=style&index=0&id=141099e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141099e2"]])

export default __exports__